"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var react_i18next_1 = require("react-i18next");
var classnames_1 = __importDefault(require("classnames"));
var i18n_1 = __importDefault(require("../../i18n"));
var filters_1 = require("../../helpers/filters");
var searchParamsSlice_1 = require("../../features/searchParams/searchParamsSlice");
var currencySlice_1 = require("../../features/currencies/currencySlice");
var Localization_1 = require("../../constants/Localization");
var HomeLocationPicker_1 = __importDefault(require("../HomeLocationPicker"));
var HomeCheckbox_1 = __importDefault(require("../HomeCheckbox"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var DEALS = ['buy', 'rent', 'daily'];
var PROPERTY_TYPES = [
    'apartment',
    'house',
    'townhouse',
    'land',
    'commercial',
];
var ROOMS = ['studio', '1', '2', '3', '4', '5+'];
var CURRENCIES = [
    { code: 'AMD', symbol: '֏' },
    { code: 'USD', symbol: '$' },
    { code: 'RUB', symbol: '₽' },
];
// Rooms make no sense for land or commercial property.
var TYPES_WITHOUT_ROOMS = ['land', 'commercial'];
// "New building" checkbox: ticked sends structure_type=new_building (the value
// stored on posts and read by the search page); unticked means no filter.
var NEW_BUILDING = 'new_building';
// Land has no building, so the "new building" checkbox doesn't apply to it.
var TYPES_WITHOUT_BUILDING = ['land'];
// Shown for the demo but not selectable: these property types don't exist
// on the site yet (listings can be apartment, house, commercial or land).
var UNAVAILABLE_TYPES = ['townhouse'];
// Property types nobody rents out by the day: the "daily" tab is greyed out for them.
var TYPES_WITHOUT_DAILY = ['land'];
// Same range format as the search filter schema (config/schemas/filters).
// "studio" has no agreed range yet, so it is not sent.
var ROOM_RANGES = {
    '1': 'gte_1-lt_2',
    '2': 'gte_2-lt_3',
    '3': 'gte_3-lt_4',
    '4': 'gte_4-lt_5',
    '5+': 'gte_5',
};
var T = 'HOME.SEARCH_FORM';
var onlyDigits = function (value) { return value.replace(/\D/g, ''); };
var formatNumber = function (digits) {
    return digits ? Number(digits).toLocaleString('en-US') : '';
};
// "50000" + "80000" -> "gte_50000-lte_80000"; one side only -> one condition.
var buildRange = function (min, max) {
    var parts = [];
    if (min)
        parts.push("gte_" + min);
    if (max)
        parts.push("lte_" + max);
    return parts.length ? parts.join('-') : null;
};
var HomeSearchForm = function () {
    var _a, _b;
    var _c, _d;
    var t = react_i18next_1.useTranslation('common').t;
    var history = react_router_dom_1.useHistory();
    var dispatch = react_redux_1.useDispatch();
    var _e = react_1.useState('buy'), deal = _e[0], setDeal = _e[1];
    var _f = react_1.useState('apartment'), propertyType = _f[0], setPropertyType = _f[1];
    var _g = react_1.useState([]), rooms = _g[0], setRooms = _g[1];
    var _h = react_1.useState(false), onlyNewBuildings = _h[0], setOnlyNewBuildings = _h[1];
    // Shared with the header switcher: one currency for the whole site, so the
    // price typed here and the prices on the cards are in the same units.
    var currency = react_redux_1.useSelector(currencySlice_1.selectCurrentCurrency).toUpperCase();
    var _j = react_1.useState(''), priceMin = _j[0], setPriceMin = _j[1];
    var _k = react_1.useState(''), priceMax = _k[0], setPriceMax = _k[1];
    var _l = react_1.useState(''), areaMin = _l[0], setAreaMin = _l[1];
    var _m = react_1.useState(''), areaMax = _m[0], setAreaMax = _m[1];
    var _o = react_1.useState({
        stateIds: [],
        districtIds: [],
        place: null,
    }), location = _o[0], setLocation = _o[1];
    // 1. Deal picks the page: sell page for "buy", rent page for "rent"/"daily";
    //    daily vs monthly is narrowed with rental_price_type.
    // 2. Every filled field becomes a query param the search page already reads;
    //    empty fields are left out so they don't filter anything.
    // 3. Location, in order of priority:
    //    - an address from the autocomplete -> viewBox + address, same as the old
    //      home banner (the search page then searches by the box on the map);
    //    - regions/communities -> repeated ?state= / ?district= (government ids);
    //    - nothing -> the old home page default state (Yerevan).
    var buildSearchUrl = function () {
        var prefixes = Localization_1.SellPagePrefix[i18n_1.default.language];
        var params = new URLSearchParams({ page: '1' });
        if (deal === 'rent')
            params.append('rental_price_type', 'monthly_price');
        if (deal === 'daily')
            params.append('rental_price_type', 'daily_price');
        params.append('property_type', propertyType);
        if (hasRooms) {
            rooms
                .map(function (room) { return ROOM_RANGES[room]; })
                .filter(Boolean)
                .forEach(function (range) { return params.append('rooms', range); });
        }
        // Kept but not sent for land: it has no building, the filter would empty the results.
        if (hasBuilding && onlyNewBuildings) {
            params.append('structure_type', NEW_BUILDING);
        }
        var priceRange = buildRange(priceMin, priceMax);
        if (priceRange) {
            params.append('price', currency.toLowerCase() + "~" + priceRange);
        }
        var areaRange = buildRange(areaMin, areaMax);
        if (areaRange)
            params.append('area', areaRange);
        var page = deal === 'buy' ? prefixes.sell : prefixes.rent;
        if (location.place) {
            var placeQuery = filters_1.createQueryUrl({
                viewBox: location.place.geometry,
                address: location.place.address,
            });
            return "/" + page + "?" + params.toString() + "&" + placeQuery;
        }
        location.stateIds.forEach(function (id) { return params.append('state', String(id)); });
        location.districtIds.forEach(function (id) {
            return params.append('district', String(id));
        });
        if (location.stateIds.length)
            return "/" + page + "?" + params.toString();
        var defaultState = Localization_1.LocalizationSettings.defaultState.replace('?', '');
        return "/" + page + "?" + params.toString() + "&" + defaultState;
    };
    var handleSubmit = function (e) {
        e.preventDefault();
        // Same as the old home banner: the search page reads the map box from the store too.
        if (location.place) {
            dispatch(searchParamsSlice_1.setViewBox({ viewBox: location.place.geometry }));
        }
        history.push(buildSearchUrl());
    };
    // 1. Pick the property type.
    // 2. If "daily" was chosen and this type has no daily rent, fall back to
    //    "buy" (the form default) so the search isn't sent with a greyed-out deal.
    var selectPropertyType = function (type) {
        setPropertyType(type);
        if (deal === 'daily' && TYPES_WITHOUT_DAILY.includes(type)) {
            setDeal('buy');
        }
    };
    var toggleRoom = function (room) {
        setRooms(function (selected) {
            return selected.includes(room)
                ? selected.filter(function (r) { return r !== room; })
                : __spreadArray(__spreadArray([], selected), [room]);
        });
    };
    var getPriceLabel = function () {
        if (deal === 'rent')
            return t(T + ".PRICE_MONTHLY");
        if (deal === 'daily')
            return t(T + ".PRICE_DAILY");
        return t(T + ".PRICE");
    };
    var getAreaLabel = function () {
        if (propertyType === 'land')
            return t(T + ".AREA_LAND");
        if (propertyType === 'house' || propertyType === 'townhouse') {
            return t(T + ".AREA_HOUSE");
        }
        return t(T + ".AREA");
    };
    // Why a property type can't be picked right now, if it can't:
    // "soon" - not on the site yet (townhouse); "daily" - no daily rent for it (land).
    var getTypeBlockReason = function (type) {
        if (UNAVAILABLE_TYPES.includes(type))
            return 'soon';
        if (deal === 'daily' && TYPES_WITHOUT_DAILY.includes(type)) {
            return 'daily';
        }
        return null;
    };
    var getTypeBlockTitle = function (reason) {
        if (reason === 'soon')
            return t('NEW_HEADER.SOON');
        if (reason === 'daily')
            return t(T + ".TYPE_UNAVAILABLE_DAILY");
        return undefined;
    };
    var currencySymbol = (_d = (_c = CURRENCIES.find(function (c) { return c.code === currency; })) === null || _c === void 0 ? void 0 : _c.symbol) !== null && _d !== void 0 ? _d : '';
    var hasRooms = !TYPES_WITHOUT_ROOMS.includes(propertyType);
    var hasBuilding = !TYPES_WITHOUT_BUILDING.includes(propertyType);
    var isDailyUnavailable = TYPES_WITHOUT_DAILY.includes(propertyType);
    return (react_1.default.createElement("form", { className: styles_module_scss_1.default.form, onSubmit: handleSubmit },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.deals }, DEALS.map(function (d) {
            var _a;
            var isDisabled = d === 'daily' && isDailyUnavailable;
            return (react_1.default.createElement("button", { key: d, type: "button", "aria-disabled": isDisabled, "data-hint": isDisabled
                    ? t(T + ".DAILY_UNAVAILABLE")
                    : undefined, className: classnames_1.default(styles_module_scss_1.default.deal, (_a = {},
                    _a[styles_module_scss_1.default.deal_active] = deal === d,
                    _a[styles_module_scss_1.default.deal_disabled] = isDisabled,
                    _a)), onClick: function () {
                    if (!isDisabled)
                        setDeal(d);
                } }, t(T + ".DEAL_" + d.toUpperCase())));
        })),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.field },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.label }, t(T + ".PROPERTY_TYPE")),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.chips }, PROPERTY_TYPES.map(function (type) {
                var _a;
                var blockReason = getTypeBlockReason(type);
                return (react_1.default.createElement("button", { key: type, type: "button", "aria-disabled": !!blockReason, "data-hint": getTypeBlockTitle(blockReason), className: classnames_1.default(styles_module_scss_1.default.chip, (_a = {},
                        _a[styles_module_scss_1.default.chip_active] = propertyType === type,
                        _a[styles_module_scss_1.default.chip_soon] = blockReason === 'soon',
                        _a[styles_module_scss_1.default.chip_disabled] = blockReason === 'daily',
                        _a)), onClick: function () {
                        if (!blockReason)
                            selectPropertyType(type);
                    } }, t(T + ".TYPE_" + type.toUpperCase())));
            }))),
        react_1.default.createElement("div", { className: classnames_1.default(styles_module_scss_1.default.field, (_a = {},
                _a[styles_module_scss_1.default.field_disabled] = !hasRooms,
                _a)) },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.label }, t(T + ".ROOMS")),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.chips }, ROOMS.map(function (room) {
                var _a;
                return (react_1.default.createElement("button", { key: room, type: "button", disabled: !hasRooms, className: classnames_1.default(styles_module_scss_1.default.chip, styles_module_scss_1.default.chip_square, (_a = {},
                        _a[styles_module_scss_1.default.chip_active] = hasRooms && rooms.includes(room),
                        _a)), onClick: function () { return toggleRoom(room); } }, room === 'studio' ? t(T + ".STUDIO") : room));
            }))),
        react_1.default.createElement("div", { className: classnames_1.default(styles_module_scss_1.default.field, (_b = {},
                _b[styles_module_scss_1.default.field_disabled] = !hasBuilding,
                _b)) },
            react_1.default.createElement("button", { type: "button", disabled: !hasBuilding, className: styles_module_scss_1.default.checkbox_row, onClick: function () { return setOnlyNewBuildings(function (value) { return !value; }); } },
                react_1.default.createElement(HomeCheckbox_1.default, { checked: hasBuilding && onlyNewBuildings }),
                react_1.default.createElement("span", null, t(T + ".NEW_BUILDING")))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.field },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.label }, getPriceLabel()),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.row },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.input },
                    react_1.default.createElement("input", { type: "text", inputMode: "numeric", placeholder: t(T + ".FROM"), value: formatNumber(priceMin), onChange: function (e) {
                            return setPriceMin(onlyDigits(e.target.value));
                        } }),
                    react_1.default.createElement("span", { className: styles_module_scss_1.default.suffix }, currencySymbol)),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.input },
                    react_1.default.createElement("input", { type: "text", inputMode: "numeric", placeholder: t(T + ".TO"), value: formatNumber(priceMax), onChange: function (e) {
                            return setPriceMax(onlyDigits(e.target.value));
                        } }),
                    react_1.default.createElement("span", { className: styles_module_scss_1.default.suffix }, currencySymbol)),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.currencies }, CURRENCIES.map(function (c) {
                    var _a;
                    return (react_1.default.createElement("button", { key: c.code, type: "button", className: classnames_1.default(styles_module_scss_1.default.currency, (_a = {},
                            _a[styles_module_scss_1.default.currency_active] = currency === c.code,
                            _a)), onClick: function () {
                            return dispatch(currencySlice_1.setCurrency(c.code.toLowerCase()));
                        } },
                        c.symbol,
                        " ",
                        c.code));
                })))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.field },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.label }, getAreaLabel()),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.row },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.input },
                    react_1.default.createElement("input", { type: "text", inputMode: "numeric", placeholder: t(T + ".FROM"), value: formatNumber(areaMin), onChange: function (e) {
                            return setAreaMin(onlyDigits(e.target.value));
                        } }),
                    react_1.default.createElement("span", { className: styles_module_scss_1.default.suffix }, t(T + ".SQM"))),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.input },
                    react_1.default.createElement("input", { type: "text", inputMode: "numeric", placeholder: t(T + ".TO"), value: formatNumber(areaMax), onChange: function (e) {
                            return setAreaMax(onlyDigits(e.target.value));
                        } }),
                    react_1.default.createElement("span", { className: styles_module_scss_1.default.suffix }, t(T + ".SQM"))))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.field },
            react_1.default.createElement(HomeLocationPicker_1.default, { label: t(T + ".LOCATION"), onChange: setLocation })),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.actions },
            react_1.default.createElement("button", { type: "submit", className: styles_module_scss_1.default.search }, t(T + ".SEARCH")),
            react_1.default.createElement("button", { type: "submit", className: styles_module_scss_1.default.map },
                "\uD83D\uDDFA ",
                t(T + ".ON_MAP")))));
};
exports.default = HomeSearchForm;
